import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { CFormCheck } from '@coreui/react-pro'
import Select from 'react-select'
import './ProgressNoteCard.scss'
import { getProgressNoteTemplates } from 'src/helper/backendHelper'
import { selectStyleDark, selectStyleLight } from '../../../utils/sharedCareTeamLogic'
import { getTheme } from '../../../redux/user/userSlice'

const SelectTemplateCard = ({
  setSelectedTemplate,
  selectedTemplate,
  setIsLoading,
  onCheckRadio,
  useDefaultNote,
}) => {
  const theme = useSelector(getTheme)

  const [templateList, setTemplateList] = useState([])

  useEffect(() => {
    const setInitialTemplateData = async () => {
      setIsLoading(true)

      const resTemplate = await getProgressNoteTemplates()

      if (resTemplate?.status === 'success') {
        const filteredResults = resTemplate?.results?.filter((t) => t.template_name !== 'AI Scribe')
        setTemplateList(filteredResults)
        setSelectedTemplate(filteredResults?.[0])
      }
      setIsLoading(false)
    }

    setInitialTemplateData()
  }, [setIsLoading])

  const onTemplateSelect = (value) => {
    let selected = templateList?.find((template) => template?._id === value)
    setSelectedTemplate(selected)
  }

  const options = templateList.map((template) => ({
    value: template?._id,
    label: template?.template_name,
  }))

  return (
    <>
      <div className="template-select">
        <div>
          <div className="pn-card-holder">
            <div className="pn-card">
              <p>Start a blank new</p>
              <div className="radio-select">
                <CFormCheck
                  type="radio"
                  name="template-select"
                  id="template-select"
                  value="new"
                  aria-label="..."
                  onChange={onCheckRadio}
                  checked={useDefaultNote}
                />
                <Select
                  menuShouldScrollIntoView={false}
                  className="encounter-selectbox-input"
                  styles={theme === 'light' ? selectStyleLight : selectStyleDark}
                  onChange={({ value }) => {
                    onTemplateSelect(value)
                  }}
                  options={options}
                  value={options?.find((opt) => opt.value === selectedTemplate?._id)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SelectTemplateCard
